import { Avatar, AvatarProps } from '@taxbit-private/cosmic'
import styled from 'styled-components'

import { getTokenLogo } from '../../constants/LogoMapping'

export type TokenAvatarProps = {
  token: string
} & Pick<AvatarProps, 'size'>

const TokenAvatar = ({ token, size = 'small' }: TokenAvatarProps) => {
  const logo = getTokenLogo(token)

  return (
    <>
      {logo ? (
        <StyledAvatar imageSrc={logo} size={size} altLabel={token} />
      ) : (
        <Avatar
          label={token ? token.charAt(0).toUpperCase() : ''}
          size={size}
          variant="secondary"
        />
      )}
    </>
  )
}

// TODO: Remove once Cosmic migration is complete
// Unsets vertial-align: center; style set by antd
const StyledAvatar = styled(Avatar)`
  img {
    vertical-align: unset !important;
  }
  background-color: ${({ theme }) => theme.color.white};
`

export default TokenAvatar
